import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { CommonService } from 'src/app/services/common.service';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { GrantsOutcomeAssessmentViewModalComponent } from './grants-outcome-assessment-view-modal/grants-outcome-assessment-view-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HeadService } from 'src/app/services/common/headservice';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { Model } from 'src/app/models/common';

@Component({
  selector: 'app-grants-outcome-assessment',
  templateUrl: './grants-outcome-assessment.component.html',
  styleUrls: ['./grants-outcome-assessment.component.scss']
})
export class GrantsOutcomeAssessmentComponent implements OnInit {

  columnDefs;
  operations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  appid: string;
  tempoperation: any[];
  permission: string;
  screencode: string;
  permissionCode : string;
  GrantsOutComes: UntypedFormGroup;
  collapesedOrNot: boolean = false;
  grantsapp: any;
  staticformFields:any;

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: GrantsSummaryService,
    private modalService: NgbModal,
    private commonService: CommonService,
    private header: HeadService,
    public grantsDatashare: GrantsDatashareService
  ) {
  }

  ngOnInit() {
   
    this.NavigateToGenInfo();
    this.grantsapp = this.commonService.getGrantsApp();
    this.appid = this.grantsapp.ID;
    this.getStaticFiledsData('SCR-029');
    this.GrantsOutComes = new UntypedFormGroup({
      OutcomeAssessment: new UntypedFormControl(),
      DescriptionMethod: new UntypedFormControl(),
      ApplicationID: new UntypedFormControl()
    });

    this.collapesedOrNot = false;

    var grantapp = this.commonService.getGrantsApp();
    this.appid = grantapp.ID;

this.permissionCode = "GC08";
    this.permission = this.commonService.getPagePermission(this.permissionCode ).toLowerCase();
    this.columnDefs = [
      {
        "headerName": "Assessment Date",
        "field": "assementDateStr"
      },
      {
        "headerName": "Outcome Assessment Instruments",
        "field": "INSTRUMENTS"
      },
      {
        "headerName": "Description of Methods",
        "field": "DESCRIPTION"
      },
      {
        "headerName": "Planned",
        "field": "Planned"
      },
      {
        "headerName": "Implemented ",
        "field": "Implemented"
      },
      {
        "headerName": "Reason for not implementation? ",
        "field": "REASON"
      }
    ];
    this.setSummary();
  }

  getStaticFiledsData(screenCode:string) {
    this.commonService.getScreenStaticFields(screenCode,this.appid)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
        this.columnDefs = [
          {
            "headerName": this.staticformFields.ASSESSMENT_DATE.LABEL_NAME,
            "field": "assementDateStr"
          },
          {
            "headerName": this.staticformFields.INSTRUMENTS.LABEL_NAME,
            "field": "INSTRUMENTS"
          },
          {
            "headerName": this.staticformFields.DESCRIPTION.LABEL_NAME,
            "field": "DESCRIPTION"
          },
          {
            "headerName": "Planned",
            "field": "Planned"
          },
          {
            "headerName": "Implemented ",
            "field": "Implemented"
          },
          {
            "headerName": this.staticformFields.REASON.LABEL_NAME,
            "field": "REASON"
          }
        ];
      });
  }

  setRowOperations(rowData:any[])
  {
    this.tempoperation = [ ];
        this.tempoperation.push(
          {
            "name": "View",
            "id": "view"
          });
      
    if(this.permission!="view" ) 
    {
      this.tempoperation.push(
        {
          "name": "Edit",
          "id": "edit"
        });
      this.tempoperation.push(
          {
            "name": "Delete",
            "id": "delete"
          });
    }
    
    rowData.forEach(element=>{
      this.operations = this.tempoperation.map(operation => {
        return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
      });
     
    });
    return rowData;
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }
  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    const modelRf=this.modalService.open(GrantsOutcomeAssessmentViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg modal-full-height modal-right',
      animation: true
    });
    modelRf.componentInstance.Content={
      heading: 'Edit',
      content: { id: this.selectedRow['ID'] }
    }
  }

  add() {
    let modalRef = this.modalService.open(GrantsOutcomeAssessmentViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Add',
      content: { id: "0"  }
    }
    modalRef.result.then(result=>{
      this.setSummary();
    })
  }

 edit(RecordData: any)
 {
  let modalRef = this['self'].modalService.open(GrantsOutcomeAssessmentViewModalComponent, {
    backdrop: false,
    keyboard: false,
    windowClass:'modal-vlg right modal-right',
    animation: true
  });
  modalRef.componentInstance.Content =  {
    heading: 'Edit',
    content: { id: RecordData['ID'] }
  };
  modalRef.result.then((result) => {
    this['self'].setSummary();
  });
 }

  view(RecordData: any)
  {
    let modalRef =  this['self'].modalService.open(GrantsOutcomeAssessmentViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass:'modal-vlg right modal-right',
      animation: true,
    
    });
    modalRef.componentInstance.Content =  {
      heading: 'View',
      content: { id: RecordData['ID'] }
    };
    modalRef.result.then((result) => {
      this['self'].setSummary();
    });
  }
  
  delete(RecordData: any) {
    const id = RecordData['ID'];
    let msg="";
  const modalRef = this['self'].modalService.open(DeleteBoxComponent,{backdrop: false})
      modalRef.componentInstance.Content={heading: 'Delete', custommessage: 'The outcome assessment will be deleted. Do you want to proceed ?',ProceedButtonName:"Delete", TerminateButtonName:"Cancel"}
      modalRef.result.then(result => {
      if(result=="okclick")
      {
        this['self'].summaryService.deleteOutcome(id).subscribe(result => {
          if (result.Status === 0) {             
            this['self'].commonService.SuccessBanner('Outcome deleted successfully');
              this['self'].setSummary();
          }
          else {
           // this['self'].commonservice.ValidationBanner(result.Message);

            this['self'].commonService.ValidationBanner("Outcome can't be Deleted ");
          }
        });
      }
    }); 
  }

  setSummary() {
    let model = new Model();
    model.Type = "0";
    model.Text = "A";
    model.AppId = this.appid;
    this.SearchClear();
    this.summaryService.getOutcomeSummary(model).subscribe(summary => {
     this.rowData = this.setRowOperations(summary);
    });
  }
  SearchClear() {
    this.GrantsOutComes = new UntypedFormGroup({
      OutcomeAssessment: new UntypedFormControl(),
      DescriptionMethod: new UntypedFormControl(),
      ApplicationID: new UntypedFormControl()
    });
  }
  AdvanceSearchSummary() {
    var formData = this.GrantsOutComes.value;
    formData["ApplicationID"] = this.appid;
    this.summaryService.getOutcomeSummarySearch(formData).subscribe(summary => {
     this.rowData =  this.setRowOperations(summary);
    });
  }

  NavigateToGenInfo() {
      this.appid = this.commonService.appId;
      let menuModule=this.commonService.getModuleMenu();
      if (this.appid == null || this.appid == undefined || this.appid == "") {
        const modalRefAcc = this.modalService.open(MessageBoxComponent, {});
        modalRefAcc.componentInstance.Content = { heading: '', content: { heading: '', description: 'Please save General information details to navigate to Outcome Assessment', operation: { hasConfirm: false } } };
        modalRefAcc.result.then((result) => {
          this.router.navigate(['/home/grants/my-applications/application-ext/:' + this.appid + '/geninfocme'],
            { skipLocationChange: true, queryParams: { id: this.appid, app_ext: true, module: "grants",submodule:menuModule.module, screen_type: "my-applications" } })
        });
        return false;
      }
  }
}
